import { ApplicationInfo, eLayoutType, EnvironmentService, LocalizationService, RoutesService } from '@abp/ng.core';
import { NavItemsService } from '@abp/ng.theme.shared';
import { Component, ElementRef, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, fromEvent, Subscription } from 'rxjs';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { eThemeMetronicComponents } from '../../enums/components';
import { LayoutStateService } from '../../services/layout-state.service';
import { LayoutService } from '../../services/layout.service';

@Component({
	selector: 'hedou-application-layout',
	templateUrl: './application-layout.component.html',
	styleUrls: ['./application-layout.component.less']
})
export class ApplicationLayoutComponent implements OnInit {

	selfLayout = 'default';
	asideSelfDisplay: true;
	contentClasses = '';
	contentContainerClasses = 'container';
	subheaderDisplay = true;
	contentExtended: false;
	asideCSSClasses: string;
	asideHTMLAttributes: any = {};
	headerMobileClasses = '';
	headerMobileAttributes = {};
	footerDisplay: boolean;
	footerCSSClasses: string;
	headerCSSClasses: string = 'header-fixed';
	headerHTMLAttributes: any = {};
	// offcanvases
	extrasSearchOffcanvasDisplay = false;
	extrasNotificationsOffcanvasDisplay = false;
	extrasQuickActionsOffcanvasDisplay = false;
	extrasCartOffcanvasDisplay = false;
	extrasUserOffcanvasDisplay = false;
	extrasQuickPanelDisplay = false;
	extrasScrollTopDisplay = false;

	static type = eLayoutType.application;

	headerComponentKey = eThemeMetronicComponents.ApplicationLayoutHeader;
	footerComponentKey = eThemeMetronicComponents.ApplicationLayoutFooter;
	mouseMoveSubscription: Subscription;
	containers$ = new BehaviorSubject<Array<ElementRef<HTMLElement>>>([]);

	get appInfo(): ApplicationInfo {
		return this.environment.getEnvironment().application;
	}

	constructor(
		private environment: EnvironmentService,
		private layoutState: LayoutStateService,
		private layout: LayoutService,
		private navItemsService: NavItemsService,
		public readonly routesService: RoutesService
	) { }

	ngOnInit(): void {
		
		this.layoutState.get$('themeSettings')
			.subscribe(theme => {
				this.contentContainerClasses = theme.classes.content_container.join(' ');
			});
		
	}

	listenMouseMove(containerRefs: ElementRef<HTMLElement>[]) {
		const mousemove$ = fromEvent(document, 'mousemove').pipe(
			debounceTime(50),
			filter(() => this.layoutState.get('isSidebarCollapsed')),
		);
		this.containers$.next([...this.containers$.getValue(), ...containerRefs]);
		if (this.mouseMoveSubscription) {
			this.mouseMoveSubscription.unsubscribe();
		}
		this.mouseMoveSubscription = combineLatest([mousemove$, this.containers$])
			.pipe(
				tap(([event, containers]) => {
					const elements = containers.filter(ref => ref?.nativeElement);
					const mouseOnSidebar = elements.some(ref =>
						ref?.nativeElement.contains(event.target as any),
					);

					this.layoutState.patch({ mouseOnSidebar });
				}),
			)
			.subscribe();
	}
}
